import { isGlobalFeatureEnabled } from "owa-feature-flags";

const PROJECTION_URL = "about:blank";

export default function getProjectionUrl(projectionTabId: string, freezeDryId?: string): string {
    if (isGlobalFeatureEnabled("mon-projectionCustomTitlebar")) {
        let url = `${PROJECTION_URL}?windowId=${projectionTabId}`;
        if (freezeDryId) {
            url += `&fdId=${freezeDryId}`;
        }
        return url;
    }
    else {
        return PROJECTION_URL;
    }
}
